import React from 'react';
import { RsvpFormProps, useRsvpForm } from './domain/useRsvpForm';
import GuestRsvp from './Guest';
import './RsvpForm.css';

const RsvpForm: React.FC<RsvpFormProps> = (props: RsvpFormProps) => {
  const { data, actions } = useRsvpForm(props);
  const t = actions.t;

  return (
    <form onSubmit={actions.handleSubmit}>
      <h2>{t('rsvp')}</h2>
      <div className="rsvp-form-container">
        <div className="form-group attending-section">
          <label>{t('attendingGeneral')}</label>
          <div>
            <label style={{ marginLeft: '1em' }}>
              <input
                type="radio"
                name="attending"
                value="true"
                checked={data.isAttending}
                onChange={e => actions.handleChange(e, 'attending')}
              />
              {t('attendingYes')}
            </label>
            <label style={{ marginLeft: '1em' }}>
              <input
                type="radio"
                name="attending"
                value="false"
                checked={!data.isAttending}
                onChange={e => actions.handleChange(e, 'attending')}
              />
              {t('attendingNo')}
            </label>
          </div>
        </div>
        <div className="rsvp-list">
          {data.formData.rsvps.map((rsvp, index) => (
            <React.Fragment key={index}>
              <GuestRsvp
                rsvp={rsvp}
                index={index}
                menu={data.menu}
                handleRSVPChange={actions.handleRSVPChange}
                handleMenuChoiceChange={actions.handleMenuChoiceChange}
                removeRSVP={actions.removeRSVP}
                t={t}
              />
            </React.Fragment>
          ))}
        </div>

        {data.isAttending && (
          <button type="button" className="add-guest-button" onClick={actions.addRSVP}>
            {t('addGuest')}
          </button>
        )}

        <div className="form-group message-section">
          <label>{t('message')}</label>
          <textarea
            name="message"
            value={data.formData.message}
            onChange={e => actions.handleChange(e, 'message')}
            placeholder={t('messagePlaceholder')}
          />
        </div>

        {data.error && <div className="error-message">{data.error}</div>}
        {data.isSuccess && <div className="success-message">{t('submitSuccess')}</div>}

        <button type="submit" className="submit-button" disabled={data.isSubmitting}>
          {data.isSubmitting ? t('submitting') : t('submit')}
        </button>
      </div>
    </form>
  );
};

export default RsvpForm;
